import {AsyncMultiSelectProps} from '../components/async-multi-select';

export const getAsyncMultiSelect =
  <T>(data: Omit<AsyncMultiSelectProps<T>, 'type'>) =>
  (): AsyncMultiSelectProps<T> => ({
    ...data,
    type: 'async-multi-select',
  });
